module.exports = __webpack_public_path__ + "static/media/multi-expectations.d9ce4d7f.png";